import { render, staticRenderFns } from "./GSideMenuHeader.vue?vue&type=template&id=7b4af62a&scoped=true&"
import script from "./GSideMenuHeader.vue?vue&type=script&lang=ts&"
export * from "./GSideMenuHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GSideMenuHeader.vue?vue&type=style&index=0&id=7b4af62a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4af62a",
  null
  
)

export default component.exports